export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';

export const CREATE_XML_REQUEST = 'CREATE_XML_REQUEST';
export const CREATE_XML_SUCCESS = 'CREATE_XML_SUCCESS';
export const CREATE_XML_FAILURE = 'CREATE_XML_FAILURE';

export const UPLOAD_ACTION_REQUEST = 'UPLOAD_ACTION_REQUEST';
export const UPLOAD_ACTION_SUCCESS = 'UPLOAD_ACTION_SUCCESS';
export const UPLOAD_ACTION_FAILURE = 'UPLOAD_ACTION_FAILURE';

export const SET_SELECTED_EQUIPMENT = 'SET_SELECTED_EQUIPMENT';
